// Activation funnel signals. Fire-and-forget, once per browser session per step.

import { api } from "./api";

const SENT_KEY = "spotdrop_activation_sent";

function alreadySent(step) {
  try {
    const sent = JSON.parse(sessionStorage.getItem(SENT_KEY) || "[]");
    if (sent.includes(step)) return true;
    sent.push(step);
    sessionStorage.setItem(SENT_KEY, JSON.stringify(sent));
    return false;
  } catch {
    return false;
  }
}

export function trackActivation(step) {
  if (alreadySent(step)) return;
  api.post(`/activation/${step}`).catch(() => {});
}
